import { render, staticRenderFns } from "./ListItemValor.vue?vue&type=template&id=157e4336"
import script from "./ListItemValor.vue?vue&type=script&lang=js"
export * from "./ListItemValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports